module.exports = __webpack_public_path__ + "static/media/bg.9af739f3.jpg";